import { useCallback, useContext, useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { setRouteParams } from 'containers/GlobalWrapper/actions';
import { OrganizationContext } from 'containers/GlobalWrapper/BusinessOrganizationDataValidation';
import useCurrentUser from 'hooks/useCurrentUser';
import { useFetchUserInfoQuery } from 'redux/api/userInfos.api';
import Analytics from 'utils/Analytics';
import getDomainFromEmail from 'utils/getDomainFromEmail';
import initialLoader from 'utils/initialLoader';

export const useLayout = () => {
  const { userId: currentUserId } = useCurrentUser();
  const params = useParams();
  const location = useLocation();
  const currentOrganization = useContext(OrganizationContext);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const { data: userInfo } = useFetchUserInfoQuery(
    { userId: currentUserId },
    { skip: !currentUserId },
  );

  const setAnalytics = useCallback(
    () => {
      try {
        Analytics.setUserID(currentUserId);
        Analytics.setUserProperties({ organizations_id: currentOrganization?.id });
        Analytics.setUserProperties({
          offer: currentOrganization?.offerDetails?.name,
        });

        if (currentUserId && userInfo) {
          const { email } = userInfo;

          Analytics.setUserProperties({
            mail_domain: getDomainFromEmail(email),
          });
        }
      } catch (err) {
        setError(err);
      }
    },
    [currentUserId, userInfo, currentOrganization],
  );

  useEffect(() => {
    try {
      initialLoader.hideLoader();
    } catch (err) {
      setError(err);
    }
  }, []);

  useEffect(
    () => {
      try {
        dispatch(
          setRouteParams({
            ...params,
            location: location?.pathname,
          }),
        );
      } catch (err) {
        setError(err);
      }
    },
    [dispatch, params, location?.pathname],
  );

  useEffect(
    () => {
      if (currentUserId && userInfo) setAnalytics();
    },
    [currentUserId, userInfo, setAnalytics],
  );

  return { error };
};
